import Vue from 'vue'
import VueI18Next from '@panter/vue-i18next'
import { configure } from 'vee-validate'

import i18next from './i18n'
import router from './router'
import store from './store'

import App from './App'

import VueCarousel from 'vue-carousel'
import smoothscroll from 'smoothscroll-polyfill'

configure({
    mode: 'aggressive',
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    },
    defaultMessage: (_, values) => i18next.t(`error:${values._rule_}`, values)
})

Vue.use(VueI18Next)

Vue.use(VueCarousel)

const i18n = new VueI18Next(i18next)

new Vue({
    store,
    router,
    i18n,
    render: (h) => h(App)
}).$mount('#app')

smoothscroll.polyfill()
